/* ==========================================================================
   SignStation glitch fixes, from the 30 Oct 2026 site audit.
   Each block is tagged with its issue number in the audit report.
   Loaded (deferred) from snippets/perf-layout-guards.liquid.
   ========================================================================== */
(function () {
  'use strict';

  var money = function (value, currency) {
    var n = parseFloat(value);
    if (isNaN(n)) return currency + ' ' + value;
    if (n === 0) return 'Free';
    if (currency === 'GBP') return '£' + n.toFixed(2);
    return currency + ' ' + n.toFixed(2);
  };

  /* ---------- #12 Shipping estimator: sensible UK defaults + "Free" ---------- */
  function setDefaultCountry(root) {
    (root || document).querySelectorAll('country-province').forEach(function (cp) {
      if (cp.dataset.gfDefaulted) return;
      var country = cp.querySelector('[name="address[country]"]');
      var province = cp.querySelector('[name="address[province]"]');
      if (!country) return;
      cp.dataset.gfDefaulted = '1';
      var current = country.options[country.selectedIndex];
      var isBlank = !current || current.value === '---' || current.value === '';
      if (isBlank) {
        var uk = Array.prototype.find.call(country.options, function (o) {
          return o.value === 'United Kingdom' || o.textContent.trim() === 'United Kingdom';
        });
        if (uk) {
          country.value = uk.value;
          country.dispatchEvent(new Event('change'));
        }
      }
      if (province && country.value === 'United Kingdom') {
        var england = Array.prototype.find.call(province.options, function (o) { return o.value === 'England'; });
        if (england && province.value === 'British Forces') province.value = 'England';
      }
      // Re-apply England whenever the customer switches back to the UK.
      country.addEventListener('change', function () {
        if (country.value !== 'United Kingdom' || !province) return;
        setTimeout(function () {
          if (province.value === 'British Forces') province.value = 'England';
        }, 0);
      });
    });
  }

  function patchShippingCalculator() {
    var Calc = customElements.get('shipping-calculator');
    if (!Calc || Calc.prototype.__gfPatched) return;
    Calc.prototype.__gfPatched = true;
    var original = Calc.prototype.formatShippingRates;
    Calc.prototype.formatShippingRates = function (rates) {
      original.call(this, rates);
      var list = this.resultsElement && this.resultsElement.querySelector('ul');
      if (!list || !rates || !rates.length) return;
      list.innerHTML = rates.map(function (r) {
        return '<li>' + r.presentment_name + ': ' + money(r.price, r.currency) + '</li>';
      }).join('');
    };
  }

  /* ---------- #13 Free delivery reassurance in cart ---------- */
  var truckSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M3 6h11v9H3zM14 9h4l3 3v3h-7z"/><circle cx="7" cy="17" r="1.6"/><circle cx="17" cy="17" r="1.6"/></svg>';
  function addFreeDeliveryNote() {
    var candidates = document.querySelectorAll('.tax-note, cart-drawer p, cart-drawer small, main-cart p, main-cart small, .cart p, .cart small');
    candidates.forEach(function (el) {
      if (el.children.length > 2) return;
      var text = el.textContent.replace(/\s+/g, ' ').trim();
      if (!/Shipping\s+calculated at checkout/i.test(text)) return;
      var holder = el.parentElement;
      if (!holder || holder.querySelector('.gf-free-delivery')) return;
      var note = document.createElement('p');
      note.className = 'gf-free-delivery';
      note.innerHTML = truckSvg + '<span>Free tracked UK delivery on every order</span>';
      holder.insertBefore(note, el);
    });
  }

  /* ---------- #25 Gallery dot labels count 1, 2, 3 ... ---------- */
  function fixDotLabels() {
    document.querySelectorAll('media-dots').forEach(function (dots) {
      var buttons = dots.querySelectorAll('button[aria-label^="Go to item"]');
      buttons.forEach(function (b, i) { b.setAttribute('aria-label', 'Go to item ' + (i + 1)); });
    });
  }

  /* ---------- #23 Mobile sticky Add to cart ---------- */
  function initStickyAtc() {
    if (!document.body.classList.contains('template-product')) return;
    var info = document.querySelector('product-info');
    var realBtn = info && info.querySelector('button[name="add"].product-form__submit');
    if (!realBtn || document.querySelector('.gf-sticky-atc')) return;

    var titleEl = info.querySelector('h1, .product__title');
    var priceEl = info.querySelector('.product__price');
    var bar = document.createElement('div');
    bar.className = 'gf-sticky-atc';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML =
      '<div class="gf-sticky-atc__info">' +
        '<p class="gf-sticky-atc__title"></p>' +
        '<p class="gf-sticky-atc__price"></p>' +
      '</div>' +
      '<button type="button" class="gf-sticky-atc__btn" tabindex="-1">Add to cart</button>';
    document.body.appendChild(bar);
    document.body.classList.add('gf-has-sticky-atc');

    var refresh = function () {
      bar.querySelector('.gf-sticky-atc__title').textContent = titleEl ? titleEl.textContent.replace(/\s+/g, ' ').trim().replace(/£.*$/, '').trim() : '';
      var p = priceEl && (priceEl.querySelector('.price__sale .price-item--sale, .price-item--sale, sale-price, .price__regular') || priceEl);
      bar.querySelector('.gf-sticky-atc__price').textContent = p ? (p.textContent.match(/£\s?[\d,.]+/) || [''])[0] : '';
      var live = info.querySelector('button[name="add"].product-form__submit') || realBtn;
      var disabled = live.disabled || live.getAttribute('aria-disabled') === 'true';
      var btn = bar.querySelector('.gf-sticky-atc__btn');
      btn.disabled = disabled;
      btn.textContent = disabled ? 'Sold out' : 'Add to cart';
    };
    refresh();
    if (priceEl) new MutationObserver(refresh).observe(priceEl, { childList: true, subtree: true, characterData: true });

    bar.querySelector('.gf-sticky-atc__btn').addEventListener('click', function () {
      var live = info.querySelector('button[name="add"].product-form__submit') || realBtn;
      var form = live.form || live.closest('form');
      var invalid = form ? Array.prototype.find.call(form.elements, function (el) { return el.willValidate && !el.checkValidity(); }) : null;
      // Personalisation fields live outside the form element (form="" attribute), so check those too.
      if (!invalid && form && form.id) {
        invalid = Array.prototype.find.call(document.querySelectorAll('[form="' + form.id + '"]'), function (el) { return el.willValidate && !el.checkValidity(); });
      }
      if (invalid) {
        invalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(function () { invalid.focus({ preventScroll: true }); invalid.reportValidity(); }, 400);
        return;
      }
      live.click();
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var below = entry.boundingClientRect.top > 0;
          var show = !entry.isIntersecting && !below;
          bar.classList.toggle('is-visible', show);
          bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        });
      }, { threshold: 0 }).observe(realBtn);
    }
  }

  /* ---------- #26 "Text Color" label is hard-coded in main-product.liquid and
     product-card.liquid; show the UK spelling. ---------- */
  function fixColourLabels() {
    document.querySelectorAll('.product-card__icon').forEach(function (icon) {
      var walker = document.createTreeWalker(icon, NodeFilter.SHOW_TEXT);
      var node;
      while ((node = walker.nextNode())) {
        if (node.nodeValue.trim() === 'Text Color') node.nodeValue = node.nodeValue.replace('Text Color', 'Text Colour');
      }
    });
  }

  /* ---------- #28 Cart subtotal is printed with the currency code regardless of the
     theme setting; drop the trailing "GBP". ---------- */
  function fixSubtotalCurrency() {
    document.querySelectorAll('.totals__subtotal-value').forEach(function (el) {
      if (/£[\d,.]+\s+GBP\s*$/.test(el.textContent)) el.textContent = el.textContent.replace(/\s+GBP\s*$/, '');
    });
  }

  /* ---------- run + re-run when the theme re-renders cart/product markup ---------- */
  function runAll() {
    setDefaultCountry();
    addFreeDeliveryNote();
    fixDotLabels();
    fixColourLabels();
    fixSubtotalCurrency();
  }

  function start() {
    runAll();
    initStickyAtc();
    customElements.whenDefined('shipping-calculator').then(patchShippingCalculator);
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; runAll(); });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
